import { FaBriefcase, FaBottleWater, FaPeopleGroup, FaUsersGear } from 'react-icons/fa6';

const counter = [
  {
    id: 1,
    icon: <FaBriefcase />, // Briefcase icon
    title: 'Projects Done',
    count: '20',
  },
  {
    id: 2,
    icon: <FaBottleWater />, // Bottle water icon
    title: 'Bottles Delivered',
    count: '2000',
  },
  {
    id: 3,
    icon: <FaPeopleGroup />, // People group icon
    title: 'Happy Customers',
    count: '1000',
  },
  {
    id: 4,
    icon: <FaUsersGear />, // Users gear icon
    title: 'Expert Workers',
    count: '100',
  },
];

export default counter;